<template>
  <div>
    <customDialog
      v-if="isDialogOpen"
      :title="$t('set_org')"
      childClass="info_msg"
      :show="isDialogOpen"
      @show="isDialogOpen = $event"
      :appendToBody="true"
      @confirmButn="submitAssign('ruleForm')"
      form="true"
    >
      <el-form
        status-icon
        :model="ruleForm"
        :rules="rules"
        label-position="top"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm grid grid-cols-1 gap-4 status-icon"
      >
        <el-form-item
          :label="`${$t('SUBSET')}`"
          prop="organizations"
          v-loading="organizationsLoading"
          element-loading-spinner="el-icon-loading"
        >
          <el-select
            :disabled="ruleForm.disabled"
            v-model="ruleForm.organizations"
            multiple
            clearable
            :collapse-tags="!ruleForm.disabled"
            filterable
            :placeholder="$t('SELECT_PLACEHOLDER')"
          >
            <el-option
              v-for="item in organizationsList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <template v-slot:footerConfirm>
          <el-button type="success" @click="submitForm('ruleForm')">
            {{ $t('SUBMIT') }}
          </el-button>
        </template>
      </el-form>
    </customDialog>
    <el-tooltip
      class="item"
      effect="dark"
      :content="$t('set_org')"
      placement="bottom"
    >
      <i
        class="el-icon-s-home text-xl text-blue-600 cursor-pointer"
        @click="isDialogOpen = true"
      ></i>
    </el-tooltip>
  </div>
</template>

<script>
import {
  organizationSummaryList,
  assignDriverOrg,
  assignVehcileOrg,
  assignGeofence,
  assignTag,
} from '@/api/acl'
import customDialog from '@/components/elements/dialog'

export default {
  props: ['organizationsId', 'type', 'id'],
  components: {
    customDialog,
  },
  watch: {
    isDialogOpen: {
      handler: function (val, oldVal) {
        if (val) {
          organizationSummaryList.api().then((res) => {
            if (res) {
              this.organizationsList = res.map((i) => {
                return {
                  value: i.id,
                  label: i.title,
                }
              })

              this.organizationsLoading = false
            }
          })
          setTimeout(() => {
            this.ruleForm = {
              organizations: this.organizationsId,
            }
          }, 100)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      organizationsList: [],
      organizationsLoading: true,
      isDialogOpen: false,
      ruleForm: {
        organizations: [],
      },
      rules: {
        organizations: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('SUBSET'),
            }),
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    submitAssign(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const actionPayload = {
            organizations: this.ruleForm.organizations,
            id: this.id,
          }
          let api
          switch (this.type) {
            case 'driver':
              api = assignDriverOrg
              break
            case 'vehicle':
              api = assignVehcileOrg
              break
            case 'geofence':
              api = assignGeofence
              break
            case 'tag':
              api = assignTag
              break
          }

          api.api(actionPayload).then((res) => {
            this.submitLoading = false
            if (res) {
              this.$notify.success({
                title: this.$t('set_org') + ' ' + this.$t('SUCCESSFULLY_DONE'),
                duration: 5000,
                customClass: 'succ_msg',
              })
              this.isDialogOpen = false
              this.$router.go(0)
            }
          })
        }
      })
    },
  },
}
</script>
